import { useCallback, useEffect, useState } from 'react';
import { getPublicaUploadsCount } from '../../../services/publicaUploadsService';

/**
 * CTV-732: open Publica Upload Task count for the super-admin nav badge.
 * Mirrors useAdminHelpUnread — 30s poll, errors collapse to 0 so a transient
 * API blip never paints a scary badge (or hides a real one behind an error
 * state the nav has no room to render).
 */
export function useAdminPublicaUploadsCount(enabled: boolean) {
  const [count, setCount] = useState(0);
  const [blockingCount, setBlockingCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      setBlockingCount(0);
      return;
    }
    try {
      const res = await getPublicaUploadsCount();
      setCount(res.count ?? 0);
      setBlockingCount(res.blockingCount ?? 0);
    } catch {
      setCount(0);
      setBlockingCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
    const id = setInterval(() => void refresh(), 30_000);
    return () => clearInterval(id);
  }, [refresh]);

  return { count, blockingCount, refresh };
}
